import { AfterViewChecked, Component, inject } from '@angular/core';
import { MatIconRegistry }                     from '@angular/material/icon';
import { RouterOutlet }                        from '@angular/router';
import { IframeService }                       from './core/iframe.service';
import { TitleService }                        from './core/title.service';


@Component({
  selector: 'pin-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet]
})
export class AppComponent implements AfterViewChecked {
  private readonly iframeService = inject(IframeService);
  private readonly titleService = inject(TitleService);

  constructor() {
    inject(MatIconRegistry).setDefaultFontSetClass('material-symbols-rounded');
  }

  ngAfterViewChecked(): void {
    this.titleService.init();
    this.iframeService.reportHeightChangeToParent();
  }
}
